import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';

function Header() {
    const location = useLocation();

    // Check if a path is active
    const isActive = (path) => {
        const currentPath = location.pathname;
        if (path === '/' && currentPath === '/') return true;
        if (path !== '/' && currentPath.startsWith(path)) return true;
        return false;
    };

    // Handle hamburger menu toggle
    const handleHamburgerClick = () => {
        const offcanvasArea = document.querySelector('.offcanvas__area');
        const offcanvasOverlay = document.querySelector('.offcanvas__overlay');

        if (offcanvasArea && offcanvasOverlay) {
            offcanvasArea.classList.add('info-open');
            offcanvasOverlay.classList.add('overlay-open');
        }
    };

    // Initialize menu close handlers on mount
    useEffect(() => {
        const handleCloseMenu = () => {
            const offcanvasArea = document.querySelector('.offcanvas__area');
            const offcanvasOverlay = document.querySelector('.offcanvas__overlay');

            if (offcanvasArea && offcanvasOverlay) {
                offcanvasArea.classList.remove('info-open');
                offcanvasOverlay.classList.remove('overlay-open');
            }
        };

        // Add event listeners for close button and overlay
        const closeBtn = document.querySelector('.offcanvas__close');
        const overlay = document.querySelector('.offcanvas__overlay');

        if (closeBtn) {
            closeBtn.addEventListener('click', handleCloseMenu);
        }
        if (overlay) {
            overlay.addEventListener('click', handleCloseMenu);
        }

        // Close menu on scroll
        const handleScroll = () => {
            if (window.scrollY > 0) {
                handleCloseMenu();
            }
        };
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listeners
        return () => {
            if (closeBtn) {
                closeBtn.removeEventListener('click', handleCloseMenu);
            }
            if (overlay) {
                overlay.removeEventListener('click', handleCloseMenu);
            }
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            <header>
                <div id="header-sticky" className="header__area header-2 header-1">
                    <div className="container">
                        <div className="mega__menu-wrapper p-relative">
                            <div className="header__main">
                                <div className="header__left">
                                    <div className="header__logo">
                                        <Link to="/">
                                            <div className="logo">
                                                <img src="assets/imgs/logo/logo-white.png" alt="Nexus ID Systems" className="logo-transparent" />
                                                <img src="assets/imgs/logo/logo.png" alt="Nexus ID Systems" className="logo-sticky" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="header__middle">
                                    <div className="mean__menu-wrapper d-none d-lg-block">
                                        <div className="main-menu main-menu-2">
                                            <nav id="mobile-menu" className="mobile-menu">
                                                <ul>
                                                    <li className={isActive('/') ? 'active' : ''}>
                                                        <Link to="/">Home</Link>
                                                    </li>
                                                    <li className={isActive('/printers') ? 'active' : ''}>
                                                        <Link to="/printers">Printers</Link>
                                                    </li>
                                                    <li className={isActive('/solutions') ? 'active' : ''}>
                                                        <Link to="/solutions">Card Solutions</Link>
                                                    </li>
                                                    <li className={isActive('/smart-cards') ? 'active' : ''}>
                                                        <Link to="/smart-cards">Smart Cards</Link>
                                                    </li>
                                                    <li className={isActive('/accessories') ? 'active' : ''}>
                                                        <Link to="/accessories">Accessories</Link>
                                                    </li>
                                                    <li className={isActive('/contact') ? 'active' : ''}>
                                                        <Link to="/contact">Contact Us</Link>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                <div className="header__right">
                                    <div className="header__action d-flex align-items-center">
                                       
                                         <div className="header__btn d-none d-sm-block">
                                            <Link to="/contact" className="fill-btn">
                                               Request Quote
                                            </Link>
                                        </div>

                                        <div className="header__hamburger ml-20 d-lg-none">
                                            <div className="sidebar__toggle">
                                                <button className="bar-icon" onClick={handleHamburgerClick}>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Header